import React, { useState } from "react";
import { successMsg } from "../SuccessHandler";
import ErrorCodes from "../../constants/ErrorCodes";
import SiteConfig from "../../constants/SiteConfig";
import { useInsertFunctions } from "../../functions/InsertFunctions";

const CopyProfileModal = ({
  isOpen,
  onClose,
  data,
  profiles,
  profileOptionSelected,
  setSessionNoLongerExists,
  publicIP,
}) => {
  const [copyProfilesList, setCopyProfilesList] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const { copyTracksByProfile } = useInsertFunctions();

  // Get the name of the selected profile
  let profileName = "";
  if (profiles) {
    const selectedProfile = profiles.find(
      (p) => p.ProfileID === profileOptionSelected,
    );
    if (selectedProfile) profileName = selectedProfile.ProfileName;
  }

  const profilesChangeHandler = (IDProfileSet) => {
    setCopyProfilesList((prevProfiles) => {
      const exists = prevProfiles.some(
        (profile) => profile.CopySetID === IDProfileSet,
      );
      if (exists) {
        return prevProfiles.filter(
          (profile) => profile.CopySetID !== IDProfileSet,
        );
      } else {
        return [
          ...prevProfiles,
          {
            CopyGetID: profileOptionSelected,
            CopySetID: IDProfileSet,
          },
        ];
      }
    });
    setHasChanges(true);
  };

  // Headers de la tabla
  const headers = (
    <tr className="text-center">
      <th hidden>IDProfile</th>
      <th>Profile Name</th>
    </tr>
  );

  // Rows of profiles for the table
  let tableProfiles = [];
  if (profiles) {
    tableProfiles = profiles
      .filter((item) => item.ProfileID !== profileOptionSelected)
      .map((item) => {
        const className = copyProfilesList.some(
          (copyItem) => copyItem.CopySetID === item.ProfileID,
        )
          ? "shadedRow"
          : "";

        return (
          <tr
            key={item.ProfileID}
            onClick={() => profilesChangeHandler(item.ProfileID)}
            className={className}
            style={{ cursor: "pointer" }}
          >
            <td className="d-none">{item.ProfileID}</td>
            <td style={{ verticalAlign: "middle", textAlign: "center" }}>
              {item.ProfileName}
            </td>
          </tr>
        );
      });
  }

  const handleCopyTracksByProfile = async (copyList) => {
    if (hasChanges) {
      const res = await copyTracksByProfile(
        {
          LastModification: new Date().toISOString(),
          List: copyList,
          PhoneLine: SiteConfig.LOGIN_PHONE_LINE,
          IP: publicIP,
        },
        data.LogonSessionID,
      );

      if (res?.error) {
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        }
        return;
      } else {
        successMsg("Copy Tracks By Profile");
        setCopyProfilesList([]);
        setHasChanges(false);
        onClose();
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal d-block show"
      role="dialog"
      aria-modal="true"
      tabIndex="-1"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        zIndex: 1051,
      }}
    >
      <div className="modal-dialog modal-xs" style={{ margin: "4rem auto" }}>
        <div className="modal-content">
          <div
            className="modal-header"
            style={{ backgroundColor: "#5b6671", color: "#fff" }}
          >
            <h5 className="modal-title">Copy Tracks by Profile</h5>
            <button
              type="button"
              className="close"
              onClick={() => {
                setCopyProfilesList([]);
                onClose();
              }}
              aria-label="Close"
            >
              &times;
            </button>
          </div>

          <div className="modal-body">
            <p className="lead" style={{ color: "#8c8c8c", fontSize: "16px" }}>
              Specify which Profiles will have the same configuration from
              Profile:
            </p>
            <div
              style={{
                textAlign: "center",
                color: "#1cc8e3",
                fontWeight: "bold",
                fontSize: "18px",
                marginBottom: "10px",
              }}
            >
              {profileName}
            </div>

            <div style={{ maxHeight: "350px", overflowY: "auto" }}>
              <table className="table table-hover table-sm mt-2">
                <thead
                  style={{
                    position: "sticky",
                    top: "0",
                    background: "#d9d9d9",
                    zIndex: 1,
                  }}
                >
                  {headers}
                </thead>
                <tbody className="table-lg">{tableProfiles}</tbody>
              </table>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleCopyTracksByProfile(copyProfilesList)}
            >
              Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                setCopyProfilesList([]);
                onClose();
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CopyProfileModal;
